import css from './AdminPage.module.css';
import { useState } from 'react';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import AdminContainer from '../../components/Admin/AdminContainer/AdminContainer';
import AdminLinks from '../../components/Admin/AdminLinks/AdminLinks';
import AdminContent from '../../components/Admin/AdminContent/AdminContent';

const AdminPage = () => {
  const [activeLink, setActiveLink] = useState<string>('0-1');

  const selectLinkHandler = (selectedKey: string) => {
    setActiveLink(selectedKey);
  };

  return (
    <FullScreen background="color">
      <AdminContainer 
        fitWidth 
        fullHeight 
        noBorder 
        noShadow 
        noPadding
        className={css.container}
      >
        <h1 className={css.title}>Admin</h1>
        
        <div className={css.menuContainer}>
          <AdminLinks selectedKey={activeLink} onSelect={selectLinkHandler} />
        </div>
        
        <AdminContainer 
          fitWidth 
          fullHeight 
          noPadding 
          noBorder 
          noShadow
          className={css.content}
        >
          <AdminContent selectedKey={activeLink} />
        </AdminContainer>
      </AdminContainer>
    </FullScreen>
  );
};

export default AdminPage;